import { render, staticRenderFns } from "./basic-videopicstext-swiper.vue?vue&type=template&id=3b277206&scoped=true"
import script from "./basic-videopicstext-swiper.vue?vue&type=script&lang=js"
export * from "./basic-videopicstext-swiper.vue?vue&type=script&lang=js"
import style0 from "./basic-videopicstext-swiper.vue?vue&type=style&index=0&id=3b277206&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b277206",
  null
  
)

export default component.exports